<template>
	<!--Agency -->
	<div class="landing-agency" v-if="pageAgency.elements">
		<hero :props="pageAgency.elements" :heroHome="true"></hero>

		<section class="content-description col-xs-12 no-gutters" id="section">
			<div class="copy col-xs-12 col-md-6" >
				<div class="inner-text">
					<h3 v-if="pageAgency.elements.description_title">{{pageAgency.elements.description_title.value}}</h3>
					<div v-if="pageAgency.elements.description_text" v-html="pageAgency.elements.description_text.value" class="content">{{pageAgency.elements.description_title.value}}</div>
				</div>
			</div>
			<div class="detail col-xs-12 col-md-6" v-if="pageAgency.elements.detail_image_background" :style="setBackgroundImage(pageAgency.elements.detail_image_background.value[0].url)">
				<div class="content-circles">
					<div class="inner text-center">
						<div class="agency-circle" v-if="pageAgency.elements.capitalized_billlings.value" v-in-viewport="">
							<h3>{{pageAgency.elements.capitalized_billlings.value}} <br> <i class="fix-center-flex">million</i> </h3>

						</div>
						<h2>CAPITALIZED BILLINGS</h2>
					</div>
					<div class="inner text-center">
						<div class="agency-circle" v-if="pageAgency.elements.employees.value" v-in-viewport="">
							<h3>{{pageAgency.elements.employees.value}}</h3>
						</div>
						<h2>EMPLOYEES</h2>
					</div>
					<div class="inner text-center">
						<div class="agency-circle" v-if="pageAgency.elements.dogs.value" v-in-viewport="">
							<h3>{{pageAgency.elements.dogs.value}}</h3>
						</div>
						<h2>DOGS</h2>
					</div>
				</div>
				<div class="overlay"></div>
			</div>
		</section>
		<div class="clearfix"></div>
		<section class="content-awards text-center" v-if="pageAgency.elements.awards_logos">
			<h2>Awards</h2>
			<p class="container" v-if="pageAgency.elements.awards_description">{{pageAgency.elements.awards_description.value}}</p>
			<div class="awards-container container">
				<div v-for="award in pageAgency.elements.awards_logos.value" class="award">
					<img :src="award.url" :alt="award.name">
				</div>
			</div>
		</section>
		<!-- <section class="content-agency-sliders" v-if="sliders.length" >
			<div class="container-agency-slider text-center" :style="setBackgroundImage(pageAgency.elements.timeline_background_image.value[0].url)">
				<h5>TIMELINE</h5>
				<timeline :sliders="sliders" ></timeline>
				<div class="overlay"></div>
			</div>
		</section> -->
		<!-- <section class="container-at-the-helm" v-if="helm.length">
			<div class="inside">
				<div class="text-center container">
					<h2>At the helm</h2>
					<p>{{pageAgency.elements.at_the_helm_description.value}}</p>
				</div>
				<div class="boxes-helm" v-on-click-outside="closeHelm">
					<div class="box-helm" :id="'b'+index" v-for="(box,index) in helm" :class="{active:activeHelmid==index}" v-scroll-to="{el:'#b'+index,offset:-10}" @click="selectHelm(box,index)" >
						<div class="overlay"></div>
						<div>
							<div class="bio-hover">
								<span class="bio-hover-name">{{box.name.value}}</span>
								<span class="bio-hover-role">{{box.position.value}}</span>
							</div>
							<img :src="box.image.value[0].url" :alt="box.image.value[0].name">
						</div>
					</div>
					<div id="helm-bio" class="box-bio" v-if="openHelm" :style="orderBioHelm()" >
						<span class="grey-arrow" :style="arrowHelmPosition()"></span>
						<span class="close" @click="closeHelm()"></span>
						<div >
							<div class="bio-left">
								<div class="copy">
									<h4 v-if="selectedHelm.name.value">{{selectedHelm.name.value}}</h4>
									<h5 v-if="selectedHelm.position.value">{{selectedHelm.position.value}}</h5>
									<a v-if="selectedHelm.email_address.value" :href="'mailto:'+selectedHelm.email_address.value" >{{selectedHelm.email_address.value}}</a>
									<div class="clearfix"></div>
									<div class="social-icons">
										<a class="social-icon" v-if="selectedHelm.facebook.value" :href="selectedHelm.facebook.value" target="_blank" title="Go to Marcus Thomas's Facebook"><icon name="facebook"></icon></a>
										<a class="social-icon" v-if="selectedHelm.twitter.value" :href="selectedHelm.twitter.value" target="_blank" title="Go to Marcus Thomas's Twitter"><icon name="twitter"></icon></a>
										<a class="social-icon" v-if="selectedHelm.linkedin.value" :href="selectedHelm.linkedin.value" target="_blank" title="Go to Marcus Thomas's Linked In"><icon name="linkedin"></icon></a>
									</div>
								</div>
							</div>
							<div class="bio-right">
								<p v-if="selectedHelm.bio.value">{{selectedHelm.bio.value}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<section class="container-leaders"  v-if="leaders.length">
			<div class="inside">
				<div class="text-center container">
					<h2>Executive Leadership Team</h2>
					<p>{{pageAgency.elements.excecutive_leadership_description.value}}</p>
				</div>
				<div class="boxes-leaders" v-on-click-outside="closeLeader">
					<div class="box-leader" :id="'c'+index" v-for="(box,index) in leaders"  @click="selectLeader(box,index)" :class="{active:activeLeaderid==index}" :style="putInOrder(index)" v-scroll-to="{el:'#c'+index,offset:-10}">
						<div class="overlay"></div>
						<div>
							<div class="bio-hover">
								<span class="bio-hover-name">{{box.name.value}}</span>
								<span class="bio-hover-role">{{box.position.value}}</span>
							</div>
							<img :src="box.image.value[0].url" :alt="box.image.value[0].name">
						</div>
					</div>
					<div id="leaders-bio" class="box-bio" v-if="openLeader" :style="orderBioLeaders()" >
						<span class="grey-arrow" :style="arrowLeaderPosition()"></span>
						<span class="close" @click="closeLeader()"></span>
						<div >
							<div class="bio-left">
								<div class="copy">
									<h4 v-if="selectedLeader.name.value">{{selectedLeader.name.value}}</h4>
									<h5 v-if="selectedLeader.position.value">{{selectedLeader.position.value}}</h5>
									<a v-if="selectedLeader.email_address.value" :href="'mailto:'+selectedLeader.email_address.value" >{{selectedLeader.email_address.value}}</a>
									<div class="clearfix"></div>
									<div class="social-icons">
										<a class="social-icon" v-if="selectedLeader.facebook.value" :href="selectedLeader.facebook.value" target="_blank" title="Go to Marcus Thomas's Facebook"><icon name="facebook"></icon></a>
										<a class="social-icon" v-if="selectedLeader.twitter.value" :href="selectedLeader.twitter.value" target="_blank" title="Go to Marcus Thomas's Twitter"><icon name="twitter"></icon></a>
										<a class="social-icon" v-if="selectedLeader.linkedin.value" :href="selectedLeader.linkedin.value" target="_blank" title="Go to Marcus Thomas's Linked In"><icon name="linkedin"></icon></a>
									</div>
								</div>
							</div>
							<div class="bio-right">
								<p v-if="selectedLeader.bio.value">{{selectedLeader.bio.value}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <section class="magnet-map text-center" v-if="pageAgency.elements.magnet_image">
			<img src="/dist/magnet_logo.png" alt="Magnet" class="magnet-logo hidden-xs">
			<img src="/dist/magnet_logo_mobile.png" alt="Magnet" class="magnet-logo visible-xs">
			<p class="container">Marcus Thomas is a proud member of MAGNET,  a global community of the most successful, independent advertising and marketing agencies working together to share, learn and exchange!</p>
			<img :src="pageAgency.elements.magnet_image.value[0].url" :alt="pageAgency.elements.magnet_image.value[0].name" class="map hidden-xs">
			<img :src="pageAgency.elements.magnet_image_mobile.value[0].url" :alt="pageAgency.elements.magnet_image_mobile.value[0].name" class="map visible-xs">
		</section> -->
		<section class="content-articles container-fluid" v-in-viewport="">
			<div class="inside">
				<h2 class="text-center" v-in-viewport="">Insights, commentary and news</h2>
				<articles-wrapper :boxes="relatedArticles" :isHome="true" :boxlimit="4" :pathRoute="'/words'" :showViewAll="true" :showCategory="true"></articles-wrapper>
			</div>
		</section>
		<section class="content-quote container-fluid col-xs-12" v-if="quote.elements">
			<div class="inside">
				<div class="quote-text text-center"  v-in-viewport="">
					"{{ quote.elements.quote_text.value }}"
					<span class="author">{{ quote.elements.author.value }} </span>
				</div>
			</div>
		</section><!---->






	</div>
</template>

<script>
	require('../assets/img/magnet_logo.png');
	require('../assets/img/magnet_logo_mobile.png');
	require('../assets/img/grey-triangle.png');

	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import common from '../mixins/common.js';
	import hero from '../components/hero.vue';
	import articlesWrapper from '../components/articles-wrapper.vue';
	import timeline from '../components/timeline.vue';
	import { mixin as onClickOutside } from 'vue-on-click-outside';

	export default{
		name: 'Agency',
		data(){
			return{
				pageAgency:[],
				relatedArticles:[],
				quote:[],
				sliders:[],
				openHelm:false,openLeader:false,
				helm:[],
				leaders:[],
				selectedHelm:[],selectedLeader:[],
				activeHelmid:99,activeLeaderid:99
			}
		},
		created(){
			this.getAgency();

		},
		mounted () {
			setTimeout(function(){
			    $('.st-sticky-share-buttons').addClass('st-sticky-share-buttons-show');
			},1500);
		},
		components:{
			'hero':hero,
			'articles-wrapper':articlesWrapper,
			'timeline':timeline
		},
		mixins:[apiConnection,common,onClickOutside,seoModule],
		methods:{
			// select helm functions
			selectHelm:function(box,index){
				if(this.openHelm==false) this.openHelm=true;
				this.selectedHelm = box;
				this.activeHelmid = index;
			},
			closeHelm:function(){
				this.openHelm=false;
				this.activeHelmid = 99;
			},
			orderBioHelm:function(){
				if(this.$breakpoints.isMobile() ) {
					return {
						order:(this.activeHelmid+1)
					}
				}
				else{
					if(this.activeHelmid < 4) {
						return {order:4,'margin-bottom':'3rem' }
					}
					else if(this.activeHelmid < 8) {
						return {order:8 }
					}
				}
			},
			arrowHelmPosition:function(){



				if(!this.$breakpoints.isTablet()) {
					switch(this.activeHelmid) {
						case 0:
						case 4:
						case 8:
							return {
								left:'11%'
							}
							break;
						case 1:
						case 5:
						case 9:
							return {
								left:'36.5%'
							}
							break;
						case 2:
						case 6:
						case 10:
							return {
								left:'61%'
							}
							break;
						case 3:
						case 7:
						case 11:
							return {
								left:'86.5%'
							}
							break;
					}

				}

			},
			// select leader functions
			selectLeader:function(box,index){
				if(this.openLeader==false) this.openLeader=true;
				this.selectedLeader = box;
				this.activeLeaderid = index;
			},
			closeLeader:function(){
				this.openLeader=false;
				this.activeLeaderid = 99;
			},
			orderBioLeaders:function(){
				// put bio down of selected Leader
				if(this.$breakpoints.isMobile() ) {
					if(this.activeLeaderid % 2 == 0){
						// if its even, plus one order
						return {
							order:(this.activeLeaderid + 1)
						}
					}
					else {
						// if its odd
						return {
							order:(this.activeLeaderid)
						}
					}

				}


				if(this.$breakpoints.isTablet() ) {
					if(this.activeLeaderid % 2 == 0){
						// if its even, plus one order
						return {
							order:(this.activeLeaderid + 1)
						}
					}
					else {
						// if its odd
						return {
							order:(this.activeLeaderid)
						}
					}

				}

				else{
					if(this.activeLeaderid<5){
						return{
							order:4+'!important',
							'margin-bottom':'3rem'
						}
					}
					else if(this.activeLeaderid<10){
						return{
							order:9+'!important',
							'margin-bottom':'3rem'
						}
					}
					else if(this.activeLeaderid<15){
						return{
							order:14+'!important',
							'margin-bottom':'3rem'
						}
					}
					else if(this.activeLeaderid<20){
						return{
							order:19+'!important',
							'margin-bottom':'3rem'
						}
					}
					else{
						return{
							order:24+'!important'
						}
					}
				}
			},
			arrowLeaderPosition:function(){
				if(!this.$breakpoints.isMobile() ) {
					//alert('mobile')
					switch(this.activeLeaderid) {
						case 0:
						case 5:
						case 10:
							return {
								left:'9%'
							}
							break;
						case 1:
						case 6:
						case 11:
							return {
								left:'29%'
							}
							break;
						case 2:
						case 7:
						case 12:
							return {
								left:'49%'
							}
							break;
						case 3:
						case 8:
						case 13:
							return {
								left:'69%'
							}
							break;
						case 4:
						case 9:
						case 14:
							return {
								left:'89%'
							}
							break;
					}
				}

				else{
					if(this.activeLeaderid % 2 == 0){
						return {
							left:'25%'
						}
					}
					else{
						return {
							left:'75%'
						}
					}
				}
			},
			putInOrder:function(index){
				return{
					order:index
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Agency.vue?57d4ec4d